import React, { useMemo } from 'react';
import { useImqBrokerHealthQuestionnaireParams } from 'global/hooks/useImqBrokerHealthQuestionnaireParams';
import ImqBrokerEmploymentDetailsPageStore, {
  ImqBrokerEmploymentDetailsPageStoreContext,
} from 'store/pages/quote/imq-add-employees/employment-details/pageStore';
import { PageContent } from 'components/quote/imq-add-employees/employment-details';

const ImqBrokerEmploymentDetailsPage: React.FC = () => {
  const domainParams = useImqBrokerHealthQuestionnaireParams();

  const pageStore = useMemo(
    () => new ImqBrokerEmploymentDetailsPageStore(domainParams),
    [
      domainParams.groupId,
      domainParams.periodId,
      domainParams.cartId,
      domainParams.subscriberId,
      domainParams.entityId,
    ],
  );

  return (
    <ImqBrokerEmploymentDetailsPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </ImqBrokerEmploymentDetailsPageStoreContext.Provider>
  );
};

export default ImqBrokerEmploymentDetailsPage;
